import React from 'react';

/** Small uppercase "BETA" pill for newly added, possibly-rough features. */
export const BetaPill: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center rounded-full bg-warning-100 px-2 py-0.5 text-caption-bold font-caption-bold uppercase tracking-wide text-warning-700 ${className}`}
  >
    Beta
  </span>
);
